import { render, staticRenderFns } from "./RangeSelector.vue?vue&type=template&id=04bff5e0&scoped=true&"
import script from "./RangeSelector.vue?vue&type=script&lang=ts&"
export * from "./RangeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./RangeSelector.vue?vue&type=style&index=0&id=04bff5e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bff5e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsQuantitySelector: require('/var/www/packages/theme/components/atoms/QuantitySelector.vue').default})
